import React from "react";
import { Provider } from "react-redux";
import CssBaseline from "@mui/material/CssBaseline";
import Theme from "./theme/Theme";
import store from "./store";
import { history } from "./store/history";
import Routes from "./Routes";

import { HashRouter as Router } from "react-router-dom";
function App() {
  return (
    <Provider store={store}>
      <Theme>
        <CssBaseline />
        <Router history={history}>
          <Routes />
        </Router>
      </Theme>
    </Provider>
  );
}

export default App;
